import React from 'react';
import {ARMcontext} from '../../utils/context/context';
import {SelectorImage, SelectorContainer, DropdownContainer, DropdownItem, DropdownIcon} from './styles';
import DefaultLogo from '../../assets/icons/defaultAvatar.png';
import { useNavigate } from 'react-router-dom';

export default ({src = DefaultLogo}: {src?: string}) => {
  const {HandleSignOut, user} = React.useContext(ARMcontext);
  const navigate = useNavigate();

  function handleSettings(): void {
    navigate('/config');
  }
   function handleSettingsPlayer(): void {
    navigate('/config-player');
  }

  function handleOut(): void {
    HandleSignOut();
    navigate('/login');
  }

  return (
    <SelectorContainer>
      <SelectorImage src={src === 'null' ? DefaultLogo : src} alt="Logo organization" />
      <DropdownContainer data-cy="settings" style={{position: 'absolute'}}>
        {user.role !== 'player' && (
          <DropdownItem onClick={handleSettings}>Account settings</DropdownItem>
        )}
        {user.role === 'player' && (
          <DropdownItem onClick={handleSettingsPlayer}>Account settings</DropdownItem>
        )}
        <DropdownItem onClick={handleOut} style={{ width: user.role === 'player' ? '80px' : undefined }}>
            <span> Sign out</span>
          <DropdownIcon />
        </DropdownItem>
      </DropdownContainer>
    </SelectorContainer>
  );
};
